import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { clearMobileSession } from "./session";

const isTokenValid = (token) => {
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    return decoded.exp > Date.now() / 1000;
  } catch {
    return false;
  }
};

export default function MobileProtectedRoute() {
  const accessToken = localStorage.getItem("accessToken");
  const bowAccessToken = localStorage.getItem("bow_accessToken");

  if (!isTokenValid(accessToken) || !isTokenValid(bowAccessToken)) {
    clearMobileSession();
    return <Navigate to="/mobile/login" replace />;
  }

  return <Outlet />;
}
